export default __webpack_public_path__ + "static/media/Aerotron.73e1b2ec.png";